// For a getter you will just need to map the state with the property.
export default {
  projectsSelected: state => state.projectsSelected,
  placeSearched: state => state.placeSearched,
}
